module.exports = __webpack_public_path__ + "img/cantona.531a9f7e.jpg";